module.exports = __webpack_public_path__ + "media/images/locations/basel-map-6dbbc32a2fa3578eef02da476bb4c99d.jpg";